import {Component, OnInit, ViewChild} from '@angular/core';
import {LocalizationService} from '../../../Services/localization.service';
import {Helper} from '../../../../helpers/helper.service';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {LanguageService} from '../../../../translation/Services/language.service';
import {TranslateService} from '@ngx-translate/core';
import {Grid} from '../../../../shared/Models/grid';
import {NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';

@Component({
  selector: 'app-localization-overview',
  templateUrl: './localization-overview.component.html',
  styleUrls: ['./localization-overview.component.scss', '../../../../../assets/icon/icofont/css/icofont.scss']
})
export class LocalizationOverviewComponent implements OnInit {
  public grid: Grid;

  rows = [];
  loadingIndicator = true;
  reorderable = true;

  columns = [];

  expanded = {};
  timeout: any;

  rowsFilter = [];
  tempFilter = [];
  @ViewChild(DatatableComponent, {static: false}) table: DatatableComponent;

  constructor(
    private localizationService: LocalizationService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private router: Router,
    private helper: Helper) {}

  ngOnInit(): void {
    this.grid = <Grid>{
      columns: [],
      service: this.localizationService,
      rememberURL: this.router.url,
      method: 'getAllLocalization',
    };

    this.languageService.list().subscribe(resp => {
      const columns = [
        <NumberColumn>{
          name: 'doctrine.attributes.domain',
          prop: 'domain',
          sortable: true,
          type: TextColumn.type,
          translate: true
        }
      ];
      for (const lang of resp.languages) {
        columns.push(<TextColumn>{
          name: lang.name,
          prop: lang.name,
          sortable: false,
          type: TextColumn.type,
          translate: false,
          valueClassFormatter: (col) => {
            const numbers = col.split('/', 2);
            if (numbers[0] === numbers[1]) {
              return 'text-success';
            }
            return 'text-danger';
          }
        });
      }
      this.grid.columns = columns;
      this.grid = {...this.grid};
    });
  }
}
